import types from 'frontend/state/actionTypes';

function flashReducer(state = null, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case types.FLASH_MESSAGE:
      return payload;
    case types.DISMISS_FLASH:
      return null;
    default:
      return state;
  }
}

export default flashReducer;

export const selectors = {
  message: state => state.flash,
};
